import { TResponse } from '../../../common/types';
import { superAppApi } from '../../../core';

import { ICategory } from '../types';

const categoryApi = superAppApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getCategory: build.query<ICategory, { categoryId: string }>({
      query: ({ categoryId }) => ({
        url: `/categories/${categoryId}`,
      }),
      providesTags: (result, error, { categoryId }) => [
        { type: 'Category', id: categoryId },
      ],
    }),
    getCategories: build.query<ICategory[], void>({
      query: () => ({
        url: '/categories',
      }),
      transformResponse: (response: TResponse<ICategory[]>) => response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Category' as const, id })),
              { type: 'Category', id: 'LIST' },
            ]
          : [{ type: 'Category', id: 'LIST' }],
    }),
    updateCategory: build.mutation<
      TResponse<ICategory>,
      { id: string; attributes: ICategory['attributes'] }
    >({
      query: ({ id, attributes }) => {
        console.log(attributes);
        return {
          url: `/categories/${id}`,
          method: 'PATCH',
          body: attributes,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: 'Category', id },
        { type: 'Category', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCategoryQuery,
  useGetCategoriesQuery,
  useUpdateCategoryMutation,
} = categoryApi;
